import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { get } from 'lodash';
import { verificationEmail } from 'libs/api/user';
import { showNotification, sleep } from 'libs/utils';
import { ENotificationType } from 'enums/base.enum';

const VerificationEmail = () => {
  let { uidb64 = '' } = useParams();
  const history = useHistory();

  const handleVerification = async (uidb64: string) => {
    try {
      const response = await verificationEmail(uidb64);

      showNotification(
        ENotificationType.Success,
        `${get(response, 'data.for_userid')}님의 전/현직 인증이 완료되었습니다.`,
      );
      await sleep(2000);
      window.location.href = '/';
    } catch (e) {
      await sleep(2000);
      window.location.href = '/';
    }
  };

  useEffect(() => {
    handleVerification(uidb64);
  }, []);

  return <></>;
};
export default VerificationEmail;
